import React                            from 'react';
import { Observe }                      from 'rewire-core';
import {
  WithStyle,
}                                       from 'rewire-ui';
import { Theme }                        from '@material-ui/core/styles';
import { makeStyles, withStyles }       from '../utility/styles';
import archiveDeleteAreaDialogModel     from './ArchiveDeleteAreaDialogModel';
import ArchiveDeleteDialog              from './ArchiveDeleteDialog';

const contentStyles = (_theme: Theme) => ({
  list: {
    listStylePosition: 'inside',
    textAlign: 'left',
    display: 'inline-block',
  },
});

const useContentStyles = makeStyles(contentStyles);

export const ArchiveDeleteAreaConfirmationContent = () => {
  const classes = useContentStyles();

  return <Observe render={() => {
    const area        = archiveDeleteAreaDialogModel.name;
    const date        = archiveDeleteAreaDialogModel.endDateString;
    const taskDisplay = archiveDeleteAreaDialogModel.taskDisplay;
    return (
      < >
      <div>
        <div>
          All Groups for: {area} will be archived.
        </div>
        <div>
          All transactions for: {area}<br />
          As of: {date} will be deleted from WorkSight for:
        </div>
        <ul className={classes.list}>
          <li>Timecards</li>
          <li>Jobs</li>
        </ul>
        <div>
          Enter Area Name to Confirm {taskDisplay}:
        </div>
      </div>
      </>
    );
  }} />;
};

const styles = (_theme: Theme) => ({
});

interface IArchiveDeleteAreaDialogProps {
}

type ArchiveDeleteAreaDialogProps = WithStyle<ReturnType<typeof styles>, IArchiveDeleteAreaDialogProps>;

class ArchiveDeleteAreaDialog extends React.PureComponent<ArchiveDeleteAreaDialogProps> {
  constructor(props: ArchiveDeleteAreaDialogProps) {
    super(props);
  }

  render() {
    return <Observe render={() => (
      <ArchiveDeleteDialog model={archiveDeleteAreaDialogModel} />
    )} />;
  }
}

export default withStyles<IArchiveDeleteAreaDialogProps>(styles, ArchiveDeleteAreaDialog);
